<template>
    <v-navigation-drawer
      class="nav-drawer"
      :width="380"
      height="90%"
      v-model="shown"
      absolute
      dark
      temporary
    >
      <v-list class="pa-1">
        <v-list-tile avatar tag="div">
          <v-list-tile-content>
            <v-list-tile-title>{{ venueName }}</v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn icon @click.stop="shown = false;">
              <v-icon>arrow_back</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>

      <v-list class="pt-0" dense>
        <v-list-tile
          v-for="space in spaces"
          :key="space.id"
          @click="handleClick(space)"
        >
          <v-list-tile-action>
            <v-list-tile-title>{{ space.title }}</v-list-tile-title>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  created() {
    this.shown = this.value;
  },

  data() {
    return {
      shown: false,
    };
  },

  props: {
    value: Boolean,
  },

  computed: {
    ...mapState({
      spaces: 'spaces',
      selectedDate: 'selectedDate',
      venueName: state => state.device.venue.name,
    }),
  },

  methods: {
    ...mapMutations(['setSpace']),
    ...mapActions(['fetchBookings']),

    handleClick(space) {
      this.setSpace(space);
      this.fetchBookings({
        date: this.selectedDate.format('YYYY-MM-DD'),
        spaceId: space.id,
      }).then(() => {
        this.shown = false;
      });
    },
  },

  watch: {
    shown(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.shown = val;
    },
  },
};
</script>

<style lang="scss">
  .nav-drawer {
    border-radius: 24px;
    box-shadow: 0 50px 33px 0 rgba(0,0,0,0.5), 0 -24px 31px 0 rgba(0,0,0,0.5);

    &.theme--dark.v-navigation-drawer {
      &.v-navigation-drawer--close {
        left: 0;
      }
      background-color: #11141F;
      padding: 34px;
      left: 30px;
      top: 5%;
    }

    .pa-1 .v-list__tile {
      .v-list__tile__title {
        font-size: 25px;
        text-decoration: underline;
      }
    }

    a.v-list__tile.v-list__tile--link.theme--dark {
      opacity: 0.9;
      color: #FFFFFF;
      font-size: 25px;
      margin-top: 45px;

      &:hover {
        color: #7ED321;
      }

      .v-list__tile__title {
        height: 30px;
        letter-spacing: -0.21px;
        line-height: 30px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Navigation.vue